module.exports = __webpack_public_path__ + "img/weddings_08_V.a869e9c3.webp";